// layouts/Theme001.js
// layouts/Theme001.js
import { Avatar } from "antd";
import { PiPhoneFill } from "react-icons/pi";
import { IoLocationSharp, IoMailSharp } from "react-icons/io5";
import { FaWhatsapp, FaInstagram, FaLinkedin } from "react-icons/fa";
import { RiFacebookCircleLine } from "react-icons/ri";
import QRCode from "react-qr-code";
import { FaLocationPin } from "react-icons/fa6";
const parseColor = (hex) => {
  if (!hex) return "#ffffff"; // default fallback
  // If it's 8-digit hex (ARGB), drop the alpha or convert to RGBA
  if (hex.length === 8) {
    const a = parseInt(hex.substring(0, 2), 16) / 255;
    const r = parseInt(hex.substring(2, 4), 16);
    const g = parseInt(hex.substring(4, 6), 16);
    const b = parseInt(hex.substring(6, 8), 16);
    return `rgba(${r},${g},${b},${a})`;
  }
  return `#${hex}`;
};
const decideCardTextColor = (hex) => {
  if (!hex) return "#000000"; // fallback

  // remove "#" if present
  hex = hex.replace("#", "");

  // expand shorthand (#fff → #ffffff)
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }

  let r, g, b;

  if (hex.length === 8) {
    // ARGB → ignore alpha for luminance
    r = parseInt(hex.substr(2, 2), 16);
    g = parseInt(hex.substr(4, 2), 16);
    b = parseInt(hex.substr(6, 2), 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.substr(0, 2), 16);
    g = parseInt(hex.substr(2, 2), 16);
    b = parseInt(hex.substr(4, 2), 16);
  } else {
    return "#000000"; // fallback for invalid hex
  }

  // compute luminance (same as Flutter's computeLuminance)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "#000000" : "#ffffff";
};

export const Theme001 = ({ cardsData, defaultimage }) => {
  const bgColor = parseColor(cardsData?.color);
  const textColor = decideCardTextColor(cardsData?.color);

  return (
    <>
      <div className="front theme-001-front">
        <div className="business-card-container">
          <div className="business-card-second-container">
            <div className="business-card-profile">
              <div
                className="business-card-image"
                style={{ backgroundColor: bgColor }}
              >
                <img src={cardsData?.image || defaultimage} alt="Profile" />
              </div>
            </div>
            <div
              className="business-card-content"
              style={{ backgroundColor: bgColor }}
            >
              <div className="business-card-button">
                <p
                  style={{
                    fontWeight: "700",
                    paddingTop: "5px",
                    color: textColor,
                  }}
                >
                  {cardsData?.yourName || "No Name Available"}
                </p>
                <p style={{ fontWeight: "500", color: textColor }}>
                  {cardsData?.designation || "No Designation Available"}
                </p>
                <hr style={{ width: "100%", color: textColor }} />
              </div>

              {/* Contact */}
              <div className="business-card-button">
                <p
                  style={{
                    fontWeight: "500",
                    marginTop: "8px",
                    color: textColor,
                  }}
                >
                  Contact
                </p>
                <a
                  href={`tel:${cardsData.mobile}`}
                  className="business-card-icon"
                >
                  <PiPhoneFill style={{ color: textColor }} />
                  <span style={{ color: textColor }}>
                    {cardsData?.mobile || "No Contact Available"}
                  </span>
                </a>
                <a
                  href={`mailto:${cardsData.email}`}
                  className="business-card-icon"
                >
                  <IoMailSharp style={{ color: textColor }} />
                  <span className="truncate-text" style={{ color: textColor }}>
                    {cardsData?.email || "No Email Available"}
                  </span>
                </a>
              </div>

              {/* Socials */}
              <div className="business-card-button">
                <span
                  className="business-card-iconss"
                  style={{ color: textColor }}
                >
                  {cardsData.whatsappNo ? (
                    <a
                      href={`https://wa.me/${cardsData.whatsappNo}`}
                      target="_blank"
                    >
                      <FaWhatsapp style={{ color: textColor }} />
                    </a>
                  ) : (
                    <FaWhatsapp style={{ color: textColor }} />
                  )}

                  {cardsData.location ? (
                    <a
                      href={`https://www.google.com/maps?q=${encodeURIComponent(
                        cardsData.location
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IoLocationSharp style={{ color: textColor }} />
                    </a>
                  ) : (
                    <IoLocationSharp style={{ color: textColor }} />
                  )}

                  {cardsData.instagramLink ? (
                    <a href={cardsData.instagramLink} target="_blank">
                      <FaInstagram style={{ color: textColor }} />
                    </a>
                  ) : (
                    <FaInstagram style={{ color: textColor }} />
                  )}

                  {cardsData.twitterLink ? (
                    <a href={cardsData.twitterLink} target="_blank">
                      <FaLinkedin style={{ color: textColor }} />
                    </a>
                  ) : (
                    <FaLinkedin style={{ color: textColor }} />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="back theme-001-back">
        <div className="back-card-container">
          <div className="back-card-second-container">
            <div className="back-card-profile">
              <div className="back-card-image">
                <Avatar src={cardsData?.image || defaultimage} size={84} />
              </div>
            </div>
            <div
              className="back-card-content"
              style={{ backgroundColor: bgColor }}
            >
              <div className="back-card-button">
                <p style={{ fontWeight: "700", color: textColor }}>
                  Top Product / Services
                </p>
                <hr style={{ width: "100%", color: textColor }} />
                {cardsData?.services?.length > 0 ? (
                  <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                    {cardsData.services.slice(0, 5).map((service, index) => (
                      <li style={{ color: textColor }} key={index}>
                        - {service}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span style={{ color: textColor }}>
                    Services list is not available
                  </span>
                )}
              </div>

              {cardsData?.website && (
                <a
                  href={`https://${cardsData.website}`}
                  className="back-card-website-link"
                  target="_blank"
                  style={{ color: textColor }}
                >
                  {cardsData.website}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const Theme002 = ({ cardsData, defaultimage }) => {
  const bgColor = parseColor(cardsData?.color);
  const textColor = decideCardTextColor(cardsData?.color);

  return (
    <>
      <div className="front theme-002-front">
        <div className="business-card-container">
          <div className="business-card-second-container">
            <div className="business-card-profile-002">
              <div
                className="business-card-image"
                style={{ backgroundColor: bgColor }}
              >
                <img src={cardsData?.image || defaultimage} alt="Profile" />
              </div>
            </div>
            <div
              className="business-card-content-002"
              style={{
                background: `linear-gradient(
      rgba(255, 255, 255, 0.3), 
      rgba(255, 255, 255, 0)
    ), ${bgColor}`,
              }}
            >
              <div className="business-card-button">
                <p
                  style={{
                    fontWeight: "700",
                    paddingTop: "5px",
                    color: textColor,
                  }}
                >
                  {cardsData?.yourName || "No Name Available"}
                </p>
                <p style={{ fontWeight: "500", color: textColor }}>
                  {cardsData?.designation || "No Designation Available"}
                </p>
                <hr style={{ width: "100%", color: textColor }} />
              </div>

              {/* Contact */}
              <div className="business-card-button">
                <p style={{ fontWeight: "700", color: textColor }}>Contact</p>
                <a
                  href={`tel:${cardsData.mobile}`}
                  className="business-card-icon"
                >
                  <PiPhoneFill style={{ color: textColor }} />
                  <span style={{ color: textColor }}>
                    {cardsData?.mobile || "No Contact Available"}
                  </span>
                </a>
                <a
                  href={`mailto:${cardsData.email}`}
                  className="business-card-icon"
                >
                  <IoMailSharp style={{ color: textColor }} />
                  <span className="truncate-text" style={{ color: textColor }}>
                    {cardsData?.email || "No Email Available"}
                  </span>
                </a>
              </div>

              {/* Socials */}
              <div className="business-card-button">
                <span className="business-card-iconss">
                  {cardsData.whatsappNo ? (
                    <a
                      href={`https://wa.me/${cardsData.whatsappNo}`}
                      target="_blank"
                    >
                      <FaWhatsapp style={{ color: textColor }} />
                    </a>
                  ) : (
                    <FaWhatsapp style={{ color: textColor }} />
                  )}

                  {cardsData.location ? (
                    <a
                      href={`https://www.google.com/maps?q=${encodeURIComponent(
                        cardsData.location
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IoLocationSharp style={{ color: textColor }} />
                    </a>
                  ) : (
                    <IoLocationSharp style={{ color: textColor }} />
                  )}

                  {cardsData.instagramLink ? (
                    <a href={cardsData.instagramLink} target="_blank">
                      <FaInstagram style={{ color: textColor }} />
                    </a>
                  ) : (
                    <FaInstagram style={{ color: textColor }} />
                  )}

                  {cardsData.twitterLink ? (
                    <a href={cardsData.twitterLink} target="_blank">
                      <FaLinkedin style={{ color: textColor }} />
                    </a>
                  ) : (
                    <FaLinkedin style={{ color: textColor }} />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="back theme-002-back">
        <div className="back-card-container">
          <div className="back-card-second-container">
            <div className="back-card-profile-002">
              <div className="back-card-image">
                <QRCode value={cardsData?.website} size={84} />
              </div>
            </div>

            <div
              className="back-card-content-002"
              style={{
                background: `linear-gradient(
      rgba(255, 255, 255, 0.3), 
      rgba(255, 255, 255, 0)
    ), ${bgColor}`,
              }}
            >
              <div className="back-card-button">
                <p style={{ fontWeight: "700", color: textColor }}>
                  Top Product / Services
                </p>
                <hr style={{ width: "100%", color: textColor }} />
                {cardsData?.services?.length > 0 ? (
                  <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                    {cardsData.services.slice(0, 5).map((service, index) => (
                      <li style={{ color: textColor }} key={index}>
                        - {service}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span style={{ color: textColor }}>
                    Services list is not available
                  </span>
                )}
              </div>

              {cardsData?.website && (
                <a
                  href={`https://${cardsData.website}`}
                  className="back-card-website-link"
                  target="_blank"
                  style={{ color: textColor }}
                >
                  {cardsData.website}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const Theme003 = ({ cardsData, defaultimage }) => {
  const bgColor = parseColor(cardsData?.color);
  const textColor = decideCardTextColor(cardsData?.color);

  return (
    <>
      <div className="front theme-003-front">
        <div className="business-card-container">
          <div className="business-card-second-container">
            <div className="business-card-profile-003">
              <div
                className="business-card-image"
                style={{ backgroundColor: bgColor }}
              >
                <img src={cardsData?.image || defaultimage} alt="Profile" />
              </div>
            </div>
            <div
              className="business-card-content-003"
              style={{
                background: `linear-gradient(
      rgba(255, 255, 255, 0.3), 
      rgba(255, 255, 255, 0)
    ), ${bgColor}`,
              }}
            >
              <div className="business-card-button">
                <p style={{ fontWeight: "700", paddingTop: "5px",color:textColor }}>
                  {cardsData?.yourName || "No Name Available"}
                </p>
                <p style={{ fontWeight: "500",color:textColor }}>
                  {cardsData?.designation || "No Designation Available"}
                </p>
                <hr style={{ width: "100%" ,color:textColor}} />
              </div>

              {/* Contact */}
              <div className="business-card-button">
                <p style={{ fontWeight: "700",color:textColor }}>Contact</p>
                <a
                  href={`tel:${cardsData.mobile}`}
                  className="business-card-icon"
                >
                  <PiPhoneFill style={{color:textColor}} />
                  <span style={{color:textColor}}>{cardsData?.mobile || "No Contact Available"}</span>
                </a>
                <a
                  href={`mailto:${cardsData.email}`}
                  className="business-card-icon"
                >
                  <IoMailSharp style={{color:textColor}}/>
                  <span className="truncate-text" style={{color:textColor}}>
                    {cardsData?.email || "No Email Available"}
                  </span>{" "}
                </a>
              </div>

              {/* Socials */}
              <div className="business-card-button">
                <span className="business-card-iconss">
                  {cardsData.whatsappNo ? (
                    <a
                      href={`https://wa.me/${cardsData.whatsappNo}`}
                      target="_blank"
                    >
                      <FaWhatsapp style={{color:textColor}}/>
                    </a>
                  ) : (
                    <FaWhatsapp style={{color:textColor}}/>
                  )}
                  {cardsData.location ? (
                    <a
                      href={`https://www.google.com/maps?q=${encodeURIComponent(
                        cardsData.location
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <IoLocationSharp style={{color:textColor}}/>
                    </a>
                  ) : (
                    <IoLocationSharp style={{color:textColor}}/>
                  )}

                  {cardsData.instagramLink ? (
                    <a href={cardsData.instagramLink} target="_blank">
                      <FaInstagram style={{color:textColor}}/>
                    </a>
                  ) : (
                    <FaInstagram style={{color:textColor}}/>
                  )}

                  {cardsData.twitterLink ? (
                    <a href={cardsData.twitterLink} target="_blank">
                      <FaLinkedin style={{color:textColor}} />
                    </a>
                  ) : (
                    <FaLinkedin style={{color:textColor}} />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="back theme-003-back">
        <div className="back-card-container">
          <div className="back-card-second-container">
            <div className="back-card-profile-003">
              <div className="back-card-image">
                <QRCode value={cardsData?.website} size={50} />
              </div>
            </div>
            <div
              className="back-card-content-003"
              style={{
                background: `linear-gradient(
      rgba(255, 255, 255, 0.3), 
      rgba(255, 255, 255, 0)
    ), ${bgColor}`,
              }}
            >
              <div className="back-card-button">
                <p style={{ fontWeight: "700" ,color:textColor}}>Top Product / Services</p>
                <hr style={{ width: "100%" ,color:textColor}} />
                {cardsData?.services?.length > 0 ? (
                  <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                    {cardsData.services.slice(0, 5).map((service, index) => (
                      <li style={{ color: textColor }} key={index}>
                        - {service}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span style={{color:textColor}}>Services list is not available</span>
                )}
              </div>
              {cardsData?.website && (
                <a
                  href={`https://${cardsData.website}`}
                  className="back-card-website-link"
                  target="_blank"
                  style={{color:textColor}}
                >
                  {cardsData.website}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const Theme004 = ({ cardsData, defaultimage }) => {
  const bgColor = parseColor(cardsData?.color);
const textColor = decideCardTextColor(cardsData?.color);

  return (
    <>
      <div
        className="front theme-004-front"
        style={{ backgroundColor: bgColor }}
      >
        <div className="business-card-container-004">
          <div
            className="business-card-image"
            style={{ backgroundColor: bgColor }}
          >
            <img src={cardsData?.image || defaultimage} alt="Profile" />
          </div>
          <div>
            <div className="business-card-button-004">
              <span className="business-card-iconss-004">
                {cardsData.whatsappNo ? (
                  <a
                    href={`https://wa.me/${cardsData.whatsappNo}`}
                    target="_blank"
                  >
                    <FaWhatsapp style={{color:textColor}}/>
                  </a>
                ) : (
                  <FaWhatsapp style={{color:textColor}}/>
                )}

                {/* {cardsData.facebookLink ? (
                  <a href={cardsData.facebookLink} target="_blank">
                    <RiFacebookCircleLine />
                  </a>
                ) : (
                  <RiFacebookCircleLine />
                )} */}

                {cardsData.instagramLink ? (
                  <a href={cardsData.instagramLink} target="_blank">
                    <FaInstagram style={{color:textColor}}/>
                  </a>
                ) : (
                  <FaInstagram style={{color:textColor}}/>
                )}

                {cardsData.twitterLink ? (
                  <a href={cardsData.twitterLink} target="_blank">
                    <FaLinkedin style={{color:textColor}} />
                  </a>
                ) : (
                  <FaLinkedin style={{color:textColor}}/>
                )}
                {cardsData.location ? (
                  <a
                    href={`https://www.google.com/maps?q=${encodeURIComponent(
                      cardsData.location
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IoLocationSharp style={{color:textColor}}/>
                  </a>
                ) : (
                  <IoLocationSharp style={{color:textColor}}/>
                )}
              </span>
            </div>
            <div className="business-card-button-004 mt-2">
              <p style={{ fontWeight: "700", paddingTop: "5px",color:textColor }}>
                {cardsData?.businessName || "No Name Available"}
              </p>
              <p style={{ fontWeight: "500",color:textColor }}>
                {cardsData?.designation || "No Designation Available"}
              </p>
            </div>
          </div>
        </div>
        <hr
          style={{
            width: "100%",
           color:textColor,
            marginTop: "10px",
            marginBottom: "10px",
            // border: "1px solid #fff",
          }}
        />
        <div className="business-card-button-004">
          <p style={{ fontWeight: "700", textAlign: "start" ,color:textColor}}>
            {cardsData?.yourName}
          </p>
          <div className="d-flex gap-4 align-items-center">
            <a href={`tel:${cardsData.mobile}`} className="business-card-icon">
              <PiPhoneFill style={{color:textColor}}/>
              <span style={{color:textColor}}>{cardsData?.mobile || "No Contact Available"}</span>
            </a>
            {cardsData?.mobile2 && (
              <a
                href={`tel:${cardsData.mobile2}`}
                className="business-card-icon"
              >
                <PiPhoneFill style={{color:textColor}} />
                <span style={{color:textColor}}>{cardsData.mobile2}</span>
              </a>
            )}
          </div>
          <a href={`mailto:${cardsData.email}`} className="business-card-icon">
            <IoMailSharp style={{color:textColor}}/>
            <span className="truncate-text" style={{color:textColor}}>
              {cardsData?.email || "No Email Available"}
            </span>{" "}
          </a>
        </div>
      </div>

      <div className="back theme-004-back" style={{ backgroundColor: bgColor }}>
        <div
          className="back-card-content-004"
          style={{ backgroundColor: bgColor }}
        >
          <div className="back-card-button-004">
            <p style={{ fontWeight: "700",color:textColor }}>Top Product / Services</p>
            <hr style={{ width: "100%",color:textColor }} className="my-2" />
            {cardsData?.services?.length > 0 ? (
              <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                {cardsData.services.slice(0, 5).map((service, index) => (
                  <li style={{ color: textColor }} key={index}>
                    - {service}
                  </li>
                ))}
              </ul>
            ) : (
              <span style={{color:textColor}}>Services list is not available</span>
            )}
          </div>
          <div className="d-flex justify-content-between align-items-center  ">
            <div>
              {cardsData?.website && (
                <a
                  href={`https://${cardsData.website}`}
                  className="back-card-website-link-004"
                  target="_blank"
                  style={{color:textColor}}
                >
                  {cardsData.website}
                </a>
              )}
            </div>
            <div className="qr-container">
              <QRCode value={cardsData?.website} size={50} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
